export const RegionalsConstant = ['CNN', 'SSP'];
